import React from 'react';

import styles from './AppLayout.module.scss';

interface AppLayoutProps {
  header: React.ReactElement;
  content: React.ReactElement;
  footer: React.ReactElement;
}

const AppLayout: React.FunctionComponent<AppLayoutProps> = ({ content, footer, header }) => {
  return (
    <>
      <div className={styles.header}>{header}</div>
      <div className={styles.scrollable}>
        <div className={`${styles.content}`}>{content}</div>
        <div className={`${styles.footer}`}>{footer}</div>
      </div>
    </>
  );
};

export default AppLayout;
